module.exports = __webpack_public_path__ + "img/57.f4296461.27fcfe2c.svg";